import { createSubsetSelector } from 'webui/utils/selectors';
export const vehicle_thermometers_state = createSubsetSelector(['temperature']);
export const vehicle_thermometers_config = createSubsetSelector([
    'temperature_conf',
    'temperature',
]);
